import { MarketNightlyRefreshOverrideIntent, MarketNightlyRefreshProviderSet } from "@app/operations/market-nightly-refresh/interfaces";
import ServiceBase from "@app/shared/serviceBase";

export class MarketNightlyRefreshService extends ServiceBase {
  public async getProviderSets(signal?: AbortSignal): Promise<MarketNightlyRefreshProviderSet[]> {
    return await this.makeGet<MarketNightlyRefreshProviderSet[]>(
      "/NetworkIntegrity/market-nightly-refresh/provider-sets",
      undefined, undefined, undefined, undefined,
      signal
    );
  }

  public async applyProviderSetOverrides(intents: MarketNightlyRefreshOverrideIntent[], signal?: AbortSignal): Promise<void> {
    return await this.makePost<void>(
      "/NetworkIntegrity/market-nightly-refresh/provider-sets/apply-overrides",
      intents,
      undefined, undefined, undefined, undefined, undefined,
      signal
    )
  }

  public async runProviderSetAnalysis(providerSetId: number, providerSetVersionId: number, signal?: AbortSignal): Promise<number> {
    return await this.makePost<number>(
      `/NetworkIntegrity/market-nightly-refresh/provider-sets/${providerSetId}/versions/${providerSetVersionId}/run`,
      undefined, undefined, undefined, undefined, undefined, undefined,
      signal
    )
  }
}